import { Flex } from '@mantine/core'
import { useEffect, useState } from 'react'

import { useAnalytics } from '@flecto/analytics'
import { useTranslation } from '@flecto/translations'
import { InputSearch } from '@flecto/ui'

type FiltersCustomersProps = {
  onFilter?: (term: string) => void
}

export function FiltersCustomers({ onFilter }: FiltersCustomersProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })
  const [_filter, setFilter] = useState('')

  const track = useAnalytics('segment')

  const handleFilterChange = (value: string) => {
    setFilter(value)
    onFilter?.(value)
  }

  useEffect(() => {
    if (_filter) {
      track('TABLE__SEARCH_APPLIED', {
        table: 'CUSTOMER',
      })
    }
  }, [_filter, track])

  return (
    <Flex gap={'md'} align={'center'}>
      <InputSearch
        placeholder={t('customer_placeholder_input')}
        onChange={handleFilterChange}
      />
    </Flex>
  )
}
